export const applicationIDcardTH ={
    applicationIDcard:'บัตรประจำตัวผู้เข้าสอบคัดเลือกเข้าศึกษา',
    academicYear:'ปีการศึกษา',
    grade:'ระดับชั้น',
    curriculum:'แผนการเรียน',
    examDate:'วันที่สอบคัดเลือก',
    no:'เลขที่ (ลำดับที่)',
    testVenue:'สถานที่สอบ',
    export:'วันที่พิมพ์เอกสาร',
    idCard:'เลขประจำตัวประชาชน',
    fullName:'ชื่อ - นามสกุล',
    formerSchool:'กำลังศึกษาอยู่ที่โรงเรียน',
    province:'จังหวัด',
    signature:'ลายมือผู้สมัคร'
}

export const applicationIDcardEN ={
    applicationIDcard:'Application ID card',
    academicYear:'Academic year',
    grade:'Grade level',
    curriculum:'Curriculum',
    examDate:'Exam date',
    no:'No.',
    testVenue:'Test venue',
    export:'Export at',
    idCard:'ID card number',
    fullName:'Fullname',
    formerSchool:'Former school',
    province:'Province',
    signature:'Applicant’s signature'
}